import { render } from "./_entry.vue?vue&type=template&id=2bae60cc"
import script from "./_entry.vue?vue&type=script&lang=js"
export * from "./_entry.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__